import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './resources/HeroSection';
import { IntroSection } from './resources/IntroSection';
import { PartnerGridSection } from './resources/PartnerGridSection';
export function ResourcesPage() {
  return <div className="min-h-screen flex flex-col bg-brand-black" data-id="element-842">
      <Navbar data-id="element-843" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-844">
        <HeroSection data-id="element-845" />
        <IntroSection data-id="element-846" />
        <PartnerGridSection data-id="element-847" />
      </main>
      <Footer data-id="element-848" />
    </div>;
}